<template>
    <div class="d-flex col-sm justify-content-center">
        <div class="container">
            <div class="row">
                <div class="order-md-2 col-md-6"><!-- col-xl-8 -->
                    <div class="alert alert-danger">Zavřeno, pouze soukromé akce.</div>
                    <p style="margin-top:2em">
                        <strong>Hradní sklípek znovu otevřen, těšíme se na Vaši návštěvu</strong><br/>
                        <ul style="margin-top:1em">
                            <li>Přijemné posezení</li>
                            <li>Hudební večery</li>
                            <li>Oslavy narozenin</li>
                            <li>Svatební hostiny</li>
                            <li>Firemní večírky</li>
<!--                            <li>Občerstvení na Vámi vybraných prostorách</li>-->
                        </ul>
                    Nabídku služeb je možno zajistit i mimo otevírací dobu po domluvě.</p>
                    <p style="margin-top:2em">
                    Dále poskytujeme catering pro společenské i jiné akce i ve Vašich prostorách.
                    </p>
                </div>
                <div class="order-md-1 col-md-3"><!-- col-xl-2 -->
                    <EventTable :small="true" :start="(new Date()).toLocaleDateString('cs-CZ')" :header="true" :events="[
                        // { date: '1.1.2020', name: 'Začátek Roku' },
                        // { date: '6.3.2020', name: 'Otevíráme' },
                        // { date: '26.3.2020', name: 'Soukromá akce' },
                        // { date: '5.6.2020', name: 'Párty 2' },
                        // { date: '12.12.2020', name: 'Párty 3' }
                        ]"/>
                </div>
                <div class="order-md-3 col-md-3 col-xl-3">
                    <OpeningTime :times="[
                // { day: 'Po', time: 'Zavreno' },
                // { day: 'Út', time: 'Zavreno' },
                // { day: 'St', time: 'Zavreno' },
                // { day: 'Čt', time: 'Zavreno' },
                // { day: 'Pá', time: '19:00 - 02:00' },
                // { day: 'So', time: '19:00 - 02:00' },
                // { day: 'Ne', time: 'Zavreno' },
            ]"/>
                </div>
            </div>
        </div>


    </div>
</template>

<script>
    // eslint-disable-next-line no-unused-vars
    import EventTable from "./components/EventTable.vue";
    // eslint-disable-next-line no-unused-vars
    var _ = require('lodash');
    // eslint-disable-next-line no-unused-vars
    const axios = require('axios');

    import OpeningTime from './components/OpeningTime.vue'

    export default {
        name: 'app',
        components: {
            OpeningTime,
            EventTable
        }
    }
</script>

<style>

</style>
